module.exports = __webpack_public_path__ + "assets/d04dda5938dee6dd9cd23519890d6e7d.mp3";